import { render, staticRenderFns } from "./PhoneSimulator.vue?vue&type=template&id=4266ae0e&scoped=true&"
import script from "./PhoneSimulator.vue?vue&type=script&lang=js&"
export * from "./PhoneSimulator.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSimulator.vue?vue&type=style&index=0&id=4266ae0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4266ae0e",
  null
  
)

export default component.exports